import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpErrorHandlerService, HandleError } from './http-error-handling.service';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'my-auth-token'
  })
};

@Injectable()
export class LookupService {
  private handleError: HandleError;

  constructor(private oauthService: OAuthService,
              private http: HttpClient,
              httpErrorHandler: HttpErrorHandlerService) {
    httpOptions.headers = httpOptions.headers.set('Authorization', this.oauthService.authorizationHeader());
    this.handleError = httpErrorHandler.createHandleError('LookupService');
  }

  // get a list of originators
  getOriginators(searchFrag = ''): Observable<any> {
    return this.http.get<any[]>(`${environment.api.client}/party/list/originators?frag=${searchFrag || ''}`, httpOptions);
  }

  // get a list of brokers
  getBrokersByOriginator(frag: any = '', originatorId, brokerPartyRoles): Observable<any> {
    return this.http.get<any[]>(`${environment.api.client}/party/list/brokers-by-originators?frag=${frag}&oprid=${originatorId}&bprtid=${brokerPartyRoles}&p=1&ps=1000`, httpOptions);
  }

  // get a list of brokers
  getContactsByBroker(brokerId): Observable<any> {
    return this.http.get<any[]>(`${environment.api.client}/party-role/${brokerId}/children/17`, httpOptions);
  }

  // get a list of results from an ABN/ACN query
  getBusinessDetails(query): Observable<any> {
    return this.http.get<any[]>(`${environment.api.abn}?on=&abn=${query}`, httpOptions)
      .pipe(
        catchError(this.handleError('getBusinessDetails', []))
      );
  }

  getEquipmentRepaymentType(id): Observable<any> {
    return this.http.get<any[]>(`${environment.api.equipment}/type/p.repaymentType?aux=${id}`, httpOptions)
      .pipe(
        catchError(this.handleError('getEquipmentRepaymentType', []))
      );
  }

  getLoanPurposeType(): Observable<any> {
    return this.http.get<any[]>(`${environment.api.types}/list/loan-purposes-with-product-category`, httpOptions)
      .pipe(
        catchError(this.handleError('getLoanPurposeType', []))
      );
  }

  getEquipmentLoanPurposeType(id): Observable<any> {
    return this.http.get<any[]>(`${environment.api.equipment}/type/p.loanPurposeTypeByProductType?aux=${id}`, httpOptions)
      .pipe(
        catchError(this.handleError('getEquipmentLoanPurposeType', []))
      );
  }

  getEquipmentProductTypes(): Observable<any> {
    return this.http.get<any[]>(`${environment.api.equipment}/type/p.productType?aux=`, httpOptions)
      .pipe(
        catchError(this.handleError('getEquipmentProductTypes', []))
      );
  }

  carLookup(query): Observable<any> {
    return this.http.get<any[]>(`https://www.loans.com.au/apply/car-loan/vehicle/search?page=1&pageSize=10&maxAgeYears=7&frag=${query}`, httpOptions)
      .pipe(
        catchError(this.handleError('carLookup', []))
      );
  }

  termrateLookup(brprId, makeId, modelId, year, pcid, purposeId): Observable<any> {
    return this.http.get<any[]>(`${environment.api.equipment}/vehicle/termrate?csrrId=&brprId=${brprId}&makeId=${makeId}&modelId=${modelId}&year=${year}&pcid=${pcid}&purpose=${purposeId}`, httpOptions)
      .pipe(
        catchError(this.handleError('termrateLookup', []))
      );
  }

  addressLookup(query): Observable<any> {
    return this.http.get<any[]>(`${environment.api.aux}/address/search/${query}`, httpOptions)
      .pipe(
        catchError(this.handleError('addressLookup', []))
      );
  }
}
